import { render, staticRenderFns } from "./ManagersCollectionPageNew.vue?vue&type=template&id=20f6d89d&scoped=true"
import script from "./ManagersCollectionPageNew.vue?vue&type=script&lang=ts"
export * from "./ManagersCollectionPageNew.vue?vue&type=script&lang=ts"
import style0 from "./ManagersCollectionPageNew.vue?vue&type=style&index=0&id=20f6d89d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6d89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f6d89d')) {
      api.createRecord('20f6d89d', component.options)
    } else {
      api.reload('20f6d89d', component.options)
    }
    module.hot.accept("./ManagersCollectionPageNew.vue?vue&type=template&id=20f6d89d&scoped=true", function () {
      api.rerender('20f6d89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/ManagersCollectionPageNew.vue"
export default component.exports